import routerOptions0 from "/home/runner/work/fundeasy/fundeasy/node_modules/.pnpm/nuxt@3.13.1_@types+node@24.13.3_db0@0.3.4_mysql2@2.3.3_sqlite3@5.1.7__encoding@0.1.13_e_214ecf4faf058cad9007e92f4d760b57/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}